import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        console.log("ScrollToTop triggered on route change:", pathname);

        // Force scrolling to the top
        document.documentElement.scrollTop = 0; // For most browsers
        document.body.scrollTop = 0; // For Safari

        // Alternative method
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    }, [pathname]);

    return null;
};

export default ScrollToTop;